import { ref } from 'vue'
import VFormError from './VFormError.js'

export default {
    components: {
        VFormError,
    },
    props: {
        id: {
            type: String,
            default: undefined,
        },
        label: {
            type: String,
            default: undefined,
        },
        options: {
            type: Array,
            required: true
        },
        required: {
            type: Boolean,
            default: false,
        },
        field: {
            type: Object,
            default: undefined,
        },
        defaultValue: {
            type: String,
            default: '',
        },
        rounded: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        props.field.$model = props.defaultValue
    },
    template: `
        <div
            v-if="options.length > 0"
            class="m-input-select"
            :class="{ '-rounded' : rounded }"
        >
            <label
                v-if="label"
                :for="id"
                class="m-input-select_label | a-text-label"
            >
                {{ label }}{{ required ? '*' : '' }}
            </label>
            <select
                :id="id"
                :class="{ 'is-filled' : !!field.$model }"
                v-model="field.$model"
            >
                <option
                    v-for="(option, i) in options"
                    :key="option.value"
                    :value="option.value"
                    :disabled="option.disabled"
                >
                    {{ option.label }}
                </option>
            </select>
            <span class="m-input-select_arrow | a-icon -ui-arrow-down">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                    <use xlink:href="assets/images/sprite.svg#ui-arrow-down" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
            </span>

            <v-form-error
                :field="field"
            ></v-form-error>
        </div>
    `
}
